<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  // People typing in this channel right now (never the current user).
  users: { type: Array, default: () => [] },
});

const { t } = useI18n();

const firstName = user =>
  (user.available_name || user.name || '').split(' ')[0];

const text = computed(() => {
  const [first, second] = props.users;
  if (!first) return '';
  if (props.users.length === 1) {
    return t('TEAM_CHAT.TYPING_ONE', { name: firstName(first) });
  }
  if (props.users.length === 2) {
    return t('TEAM_CHAT.TYPING_TWO', {
      first: firstName(first),
      second: firstName(second),
    });
  }
  return t('TEAM_CHAT.TYPING_MANY');
});
</script>

<template>
  <!-- Fixed height: the composer must not jump when someone starts typing. -->
  <div
    class="flex items-center flex-shrink-0 h-6 gap-2 px-5 text-xs text-n-slate-11"
    aria-live="polite"
  >
    <template v-if="users.length">
      <span class="flex gap-0.5">
        <span
          v-for="dot in 3"
          :key="dot"
          class="rounded-full size-1.5 bg-n-slate-9 animate-bounce"
          :class="{
            '[animation-delay:150ms]': dot === 2,
            '[animation-delay:300ms]': dot === 3,
          }"
        />
      </span>
      <span class="truncate">{{ text }}</span>
    </template>
  </div>
</template>
